import {
  PRIMARY_AIRBO_LINK_TOKEN,
  extraAirboLinkToken,
} from './airboLinkTokens';

// Pure builder for the native TinyMCE "Link to Airbo" menu items shared by
// Email.jsx and Sms.jsx. Kept free of any TinyMCE/editor APIs so it can be
// unit tested on its own: `insert(token)` performs the actual (styled)
// editor insertion and `setCampaignUuid(uuid | null)` re-points the
// broadcast's primary link.
//
// The first link in a broadcast is the primary link ({{link_to_airbo}}): it
// follows `campaignUuid`, and picking a campaign sets it. Once a primary link
// exists, changing `campaignUuid` would silently re-point every link already
// written, so from then on:
//   - the same campaign inserts the primary token again;
//   - a different campaign inserts an extra token that names that campaign,
//     and leaves `campaignUuid` alone;
//   - "Campaign homepage" is only offered while the primary link is the
//     homepage (`campaignUuid` null), since an extra homepage link has no
//     token to point at it.
export const buildLinkToAirboItems = ({
  t,
  campaigns = [],
  campaignUuid = null,
  hasPrimaryLink = false,
  setCampaignUuid,
  insert,
}) => {
  // A blank campaignUuid (undefined, null, "") all mean "the homepage".
  const primaryUuid = campaignUuid || null;

  const insertForCampaign = uuid => {
    if (!hasPrimaryLink) {
      setCampaignUuid(uuid);

      return insert(PRIMARY_AIRBO_LINK_TOKEN);
    }

    return insert(
      uuid === primaryUuid
        ? PRIMARY_AIRBO_LINK_TOKEN
        : extraAirboLinkToken(uuid),
    );
  };

  const offerHomepage = !hasPrimaryLink || !primaryUuid;

  return [
    ...(offerHomepage
      ? [
          {
            type: 'togglemenuitem',
            text: t('linkToCampaignHomepage'),
            onAction: () => insertForCampaign(null),
          },
        ]
      : []),
    ...campaigns.map(campaign => ({
      type: 'togglemenuitem',
      text: campaign.name,
      onAction: () => insertForCampaign(campaign.uuid),
    })),
  ];
};
